export const changeStreamUrl = (url = '') => {
  if (!url) {
    return ''
  }

  return url.replace('player/', 'player/stream/')
}
